import { LwApiPM } from "@techniaorg/liteweb-api";
import { LwTreeData } from "@techniaorg/liteweb-api/dist/types/lw-public-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
let treeData: LwTreeData | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    LwAPI?.getTree().then((tree: LwTreeData | Array<LwTreeData>) => {
      if (Array.isArray(tree)) {
        treeData = tree[0];
      } else treeData = tree;
    });
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_getTreeItem() {
  try {
    alert(
      "Minimum x coordinate of bounding box is " + treeData?.root.bbox.min.x
    );
  } catch {
    alert("Error. Check if the model and tree are loaded.");
  }
}

function ex_printtree() {
  if (typeof treeData === "object") {
    (document.getElementById("output") as HTMLTextAreaElement).value =
      srlze(treeData);
  } else {
    alert("Error. Check if the model and tree are loaded.");
  }
}

function srlze(obj: any) {
  // Serialize an object for printing text
  var seen: any[] = [];
  var str = JSON.stringify(
    obj,
    (_key: string, val: any) => {
      if (val != null && typeof val == "object") {
        if (seen.indexOf(val) >= 0) {
          return;
        }
        seen.push(val);
      }
      return val;
    },
    2
  );
  return str;
}

// Bind functions to buttons
document.getElementById("gettreeitem")?.addEventListener("click", async () => {
  await apiReady;
  ex_getTreeItem();
});
document.getElementById("printtree")?.addEventListener("click", async () => {
  await apiReady;
  ex_printtree();
});
